/** @jsx h */
import { h } from 'preact'

const CalendarIcon = ({
  style = {},
  fill = '#000',
  stroke = '#757575',
  width = '14',
  className = '',
  viewBox = '0 0 14 14'
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`rcc_c_calendar-icon ${className}`}
  >
    <g
      transform='translate(0 2)'
      fill='none'
      stroke={stroke}
      strokeMiterlimit='10'
      strokeWidth='1'
    >
      <rect width='14' height='12' stroke='' />
      <rect x='0.5' y='0.5' width='13' height='11' fill='' />
    </g>
    <g
      transform='translate(4)'
      fill='none'
      stroke={stroke}
      strokeMiterlimit='10'
      strokeWidth='1'
    >
      <rect width='.1' height='4' stroke='' />
      <rect x='0.5' y='0.5' height='3' fill='' />
    </g>
    <g
      transform='translate(9)'
      fill='none'
      stroke={stroke}
      strokeMiterlimit='10'
      strokeWidth='1'
    >
      <rect width='.1' height='4' stroke='' />
      <rect x='0.5' y='0.5' height='3' fill='' />
    </g>
    <g
      transform='translate(0 6)'
      fill='none'
      stroke={stroke}
      strokeMiterlimit='10'
      strokeWidth='1'
    >
      <rect width='14' height='.1' stroke='' />
      <rect x='0.5' y='0.5' width='13' fill='' />
    </g>
  </svg>
)

export default CalendarIcon
